// extracted by mini-css-extract-plugin
export var cardIcon = "_6b-5";
export var cardIconUnframed = "_6b-9";
export var checkboxCard = "_6b-0";
export var checkboxCardSelected = "_6b-4";
export var disabled = "_6b-2";
export var interactive = "_6b-1";
export var outerBorder = "_6b-3";
export var spacerMedium = "_6b-8";
export var spacerSmall = "_6b-7";
export var spacerXsmall = "_6b-6";